import React, { useEffect, useState } from "react";
import { MdFullscreen, MdFullscreenExit } from "react-icons/md";
import noImage from "../../Assets/images/no-image-4.png";
import { DROPDOWNICON, DROPUPICON } from "../../Utils/icons";
import {
  dateFormate,
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
} from "../../Utils/util";
import CustomButton from "./CustomButton";
import Image from "./Image";

export default function CustomTable(props) {
  const [data, setData] = useState(props.data);

  const [columns, setColumns] = useState(props.columns);

  const [subHeaderData, setSubHeaderData] = useState(props.subHeaderData);

  // const [subTableData, setSubTableData] = useState(props.subTableData);

  const [isFullscreen, setFullscreen] = useState(false);

  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  useEffect(() => {
    setColumns(props.columns);
  }, [props.columns]);

  useEffect(() => {
    setSubHeaderData(props.subHeaderData);
  }, [props.subHeaderData]);

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const handleCheckboxChange = (e, id, column) => {
    setData((prevData) => {
      return prevData.map((item, idx) => {
        if (idx === id) {
          // item.e.target.name = e.target.value;
          if (column.checkBoxOnChange) column.checkBoxOnChange(e, item);
          // column.checkBoxOnChange(e, {
          //   ...item,
          //   [e.target.name]: e.target.value,
          // });
          // return { ...item, [e.target.name]: !item.[e.target.name] };
        }
        return item;
      });
    });
  };

  const handleTextChange = (e, id, column) => {
    setData((prevData) => {
      return prevData.map((item, idx) => {
        if (idx === id) {
          if (column.inputOnChange) column.inputOnChange(e, item);
          // return { ...item, [e.target.name]: e.target.value };
        }
        return item;
      });
    });
  };

  const handleOnBlur = (e, id, column) => {
    setData((prevData) => {
      return prevData.map((item, idx) => {
        if (idx === id) {
          if (column.inputOnBlur) column.inputOnBlur(e, item);
          // return { ...item, [e.target.name]: e.target.value };
        }
        return item;
      });
    });
  };

  const requestSort = (key) => {
    let direction = "";
    sortConfig.key === key && sortConfig.direction === "asc"
      ? (direction = "desc")
      : (direction = "asc");
    handleSort(key, direction);
    setSortConfig({ key, direction });
  };

  const handleSort = (key, direction) => {
    if (key && !isEmptyArray(data)) {
      const sorted = [...data].sort((a, b) => {
        if (a[key] === null) return 1;
        if (b[key] === null) return -1;
        if (a[key] === null && b[key] === null) return 0;
        return (
          a[key].toString().localeCompare(b[key].toString(), "en", {
            numeric: true,
          }) * (direction === "asc" ? 1 : -1)
        );
      });
      setData(sorted);
    }
  };

  const clickHandler = (e, column, row) => {
    if (column.clickHandler) {
      column.clickHandler(row[column.accessor], e, row);
    }
  };

  const headerClickHandler = (e, column) => {
    if (column.headerClickHandler) {
      column.headerClickHandler(e, column);
    }
  };

  const getClassName = (column, row) => {
    let className = "";
    /* check for allignmnet */
    if (column.alignment === "left") {
      className = "text-left";
    } else if (column.alignment === "right") {
      className = "text-right";
    } else if (column.alignment === "center") {
      className = "text-center";
    }
    /* check for width */
    /* min-width */
    if (column.mininWidth)
      className = className + " " + `min-wt-${column.mininWidth}`;
    // className.concat(" ", `min-wt-${column.mininWidth}`);
    /* max-width */
    if (column.maxWidth)
      className = className + " " + `max-wt-${column.maxWidth}`;
    // className.concat(" ", `max-wt-${column.maxWidth}`);
    /* check for customStyle */
    if (column.customStyle)
      className = className + " " + `${column.customStyle}`;
    //  className.concat(" ", `${column.customStyle}`);
    return className;
  };

  const getHeaderClassName = (column) => {
    let className = "";
    /* check for allignmnet */
    if (column.alignment === "left") {
      className = "text-left";
    } else if (column.alignment === "right") {
      className = "text-right";
    } else if (column.alignment === "center") {
      className = "text-center";
    }
    /* check for width */
    /* min-width */
    if (column.mininWidth)
      className = className + " " + `min-wt-${column.mininWidth}`;
    // className.concat(" ", `min-wt-${column.mininWidth}`);
    /* max-width */
    if (column.maxWidth)
      className = className + " " + `max-wt-${column.maxWidth}`;
    // className.concat(" ", `max-wt-${column.maxWidth}`);
    /* check for HeaderStyle */
    if (column.headerStyle)
      className = className + " " + `${column.headerStyle}`;
    //  className.concat(" ", `${column.customStyle}`);
    return className;
  };

  const GraphProvider = (column, row, data) => {
    if (column.getGraph) {
      return column.getGraph(column, row, data);
    }
  };
  const TypeProvider = (column, row, data) => {
    if (column.getGraph) {
      return column.getGraph(column, row, data);
    }
  };

  const statusProvider = (column, status) => {
    if (column.getStatusCaption) {
      const finalStatus = column.getStatusCaption(status);
      return finalStatus;
    }
  };
  const valueConverter = (column, row, data) => {
    if (column.getValueConverter) {
      const finalStatus = column.getValueConverter(column, row, data);
      return finalStatus;
    }
  };

  const toggleFullscreen = () => {
    setFullscreen(!isFullscreen);
    /* If entering fullscreen, add an event listener to exit fullscreen on escape key press */
    if (!isFullscreen) {
      document.addEventListener("keydown", handleEscapeKey);
    } else {
      /* If exiting fullscreen, remove the event listener */
      document.removeEventListener("keydown", handleEscapeKey);
    }
  };

  const handleEscapeKey = (event) => {
    if (event.key === "Escape") {
      setFullscreen(false);
    }
  };

  return (
    <div
      className={`header_div table-wrap  ${isFullscreen ? " full-screen" : ""}`}
    >
      <div className="title-wrap">
        <div className="title">
          {props.label ? (
            <div className="table-title">{props.label}</div>
          ) : (
            <div className="table-title"></div>
          )}
        </div>
        {props.isShowFullScreen ? (
          <div className="fullScreen-toggle">
            {" "}
            {isFullscreen ? (
              <MdFullscreenExit
                onClick={toggleFullscreen}
                className="full-screen-toggle"
              />
            ) : (
              <MdFullscreen
                onClick={toggleFullscreen}
                className="full-screen-toggle"
              />
            )}
          </div>
        ) : null}
      </div>
      <div className="table-wrapper">
        <table id="" className="table">
          <thead>
            <tr>
              {columns.map((column, columnIndex) =>
                !column.isColSpan ? (
                  !column.isTopHeader ? (
                    <th
                      rowspan="2"
                      key={columnIndex}
                      className={
                        isEmptyString(column.headerStyle)
                          ? `${getHeaderClassName(column)}`
                          : `${getHeaderClassName(column)}  ${column.headerStyle
                          }`
                      }
                    >
                      {column.isHeaderButton ? (
                        <div
                          className=""
                          n
                          onClick={() =>
                            column.sortable && requestSort(column.accessor)
                          }
                        >
                          {/* <Button
                          onClick={(e) => headerClickHandler(e, column)}
                          disabled={column.headerDisable}
                          size="sm"
                          id="table-header-btn"
                        >
                          {column.headerRender}
                        </Button> */}
                        </div>
                      ) : (
                        <div
                          className=""
                          onClick={() =>
                            column.sortable && requestSort(column.accessor)
                          }
                        >
                          {column.header}
                          {column.sortable && (
                            <span className="short-toggle">
                              {sortConfig.key === column.accessor &&
                                sortConfig.direction === "asc" ? (
                                //   <DropDwnDown />
                                <DROPDOWNICON />
                              ) : (
                                //   <DropDwnUp />
                                <DROPUPICON />
                              )}
                            </span>
                          )}
                        </div>
                      )}
                      {column.isSubHeader ? (
                        !isEmpty(subHeaderData) ? (
                          <div className="bg-white text-danger text-right">
                            {toCommaSeperatedAmount(
                              subHeaderData[column.subHeaderAccessor]
                            )}
                          </div>
                        ) : null
                      ) : null}
                    </th>
                  ) : (
                    <th
                      colspan={column.colSpan}
                      key={columnIndex}
                      className={
                        isEmptyString(column.headerStyle)
                          ? `${getHeaderClassName(column)}`
                          : `${getHeaderClassName(column)}  ${column.headerStyle
                          }`
                      }
                    >
                      <div className="">{column.header}</div>
                    </th>
                  )
                ) : null
              )}
            </tr>
            {props.isEnableSpan ? (
              <tr>
                {columns.map((column, columnIndex) =>
                  column.isColSpan ? (
                    <th
                      key={columnIndex}
                      className={
                        isEmptyString(column.headerStyle)
                          ? `${getHeaderClassName(column)}`
                          : `${getHeaderClassName(column)}  ${column.headerStyle
                          }`
                      }
                    >
                      <div
                        className=""
                        onClick={() =>
                          column.sortable && requestSort(column.accessor)
                        }
                      >
                        {column.header}
                        {column.sortable && (
                          <span className="short-toggle">
                            {sortConfig.key === column.accessor &&
                              sortConfig.direction === "asc" ? (
                              <DROPDOWNICON />
                            ) : (
                              <DROPUPICON />
                            )}
                          </span>
                        )}
                      </div>{" "}
                    </th>
                  ) : null
                )}
              </tr>
            ) : null}
          </thead>
          {data != null ? (
            <tbody>
              {data.map((row, rowIndex) => (
                <tr key={rowIndex} className="">
                  {columns.map((column, columnIndex) =>
                    !column.isTopHeader ? (
                      <>
                        <td key={columnIndex} className={getClassName(column)}>
                          {column.isImage ? (
                            // <div className="spo-style-card__img-wrap">
                            //    {column.getImage(column, row, row[column.accessor])}
                            // </div>
                                                        <div className="spo-style-card__img-wrap">
                              <Image
                                url={`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_IMAGE_PATH
                                  }${row[column.accessor]}`}
                                altName={`${row[column.accessor]} - image`}
                              />
                            </div>
                          ) : null} 

                          {column.isStatus ? (
                            <div className="status">
                              {statusProvider(column, row[column.accessor])}
                            </div>
                          ) : null}

                          {column.isValueConverter ? (
                            <div >
                              {valueConverter(column, row, row[column.accessor])}
                            </div>
                          ) : null}

                          {column.isGraph ? (
                            <div className="grap-wrap">
                              <div
                                className={GraphProvider(
                                  column,
                                  row,
                                  row[column.accessor]
                                )}
                              ></div>
                            </div>
                          ) : null}

                          {column.isType ? (
                            <div className="grap-wrap">
                              {TypeProvider(column, row, row[column.accessor])}
                            </div>
                          ) : null}

                          {column.isHyperLink && column.isNumeric ? (
                            <div
                              className="hyperLink"
                              onClick={(e) => clickHandler(e, column, row)}
                            >
                              {column.isNumeric
                                ? toCommaSeperatedAmount(row[column.accessor])
                                : row[column.accessor]}
                            </div>
                          ) : null}

                          {column.isHyperLink && !column.isNumeric ? (
                            <div
                              className="hyperLink"
                              onClick={(e) => clickHandler(e, column, row)}
                            >
                              {row[column.accessor]}
                            </div>
                          ) : null}

                          {column.isNumeric && !column.isHyperLink ? (
                            <div className="isNumberic">
                              {toCommaSeperatedAmount(row[column.accessor])}
                            </div>
                          ) : null}

  {column.isDateFormate ? (
                            <div className="isDateFormate">
                              {dateFormate(row[column.accessor])}
                            </div>
                          ) : null}
                          {column.isSpecial ? (
                            <div
                              // className="hyperLink"
                              onClick={(e) => clickHandler(e, column, row)}
                            >
                              {row[column.accessor]} -{" "}
                              {row[column.specialAccessor]}
                            </div>
                          ) : null}

                          {column.isButton ? (
                            <div className="list-icon-wrap">
                              <CustomButton
                                cstmClass="icon-wrap"
                                buttonHandler={(e) =>
                                  clickHandler(e, column, row)
                                }
                                disabled={column.disable}
                                label={column.buttonRender}
                              />
                            </div>
                          ) : null}

                          {/* {column.isImage ? (
                            <div className="table-flex">
                              <img
                                src={row[column.accessor]}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = noImage;
                                }}
                                alt={column.accessor}
                                width={40}
                                height={40}
                                mode="fit"
                              />
                            </div>
                          ) : null} */}

                          {!column.isHyperLink &&
                            !column.isInputTexBox &&
                            !column.isCheckBox &&
                            !column.isButton &&
                            !column.isNumberFormat &&
                            !column.isImage &&
                            !column.isStatus &&
                            !column.isGraph &&
                            !column.isNumeric &&
                            !column.isSpecial &&
                             !column.isDateFormate &&
                            !column.isValueConverter ? (
                            <div className="">{row[column.accessor]}</div>
                          ) : null}
                        </td>
                        {/* {props.isSubTable ? (
                          !isEmpty(subTableData) ? (
                            <div className="bg-white text-danger text-right">
                              <tr>
                                <td>{subTableData[column.subTableAccessor]}</td>
                              </tr>
                            </div>
                          ) : null
                        ) : null} */}
                      </>
                    ) : null
                  )}
                </tr>
              ))}
            </tbody>
          ) : null}
        </table>
      </div>
      {data.length != 0 ? null : (
        <div className="no_Data_small">{"NO DATA"}</div>
      )}
    </div>
  );
}